export function getLinkChipDisplay(href: string) {
  const mailtoAddress = getMailtoAddress(href);
  if (mailtoAddress) return { label: mailtoAddress, title: mailtoAddress };

  return {
    label: getDomainFromUrl(href),
    title: href,
  };
}

export function getDomainFromUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    return hostname.startsWith('www.') ? hostname.slice(4) : hostname;
  } catch {
    return url;
  }
}

function getMailtoAddress(href: string) {
  try {
    const url = new URL(href);
    if (url.protocol !== 'mailto:') return null;

    const address = decodeURIComponent(url.pathname).trim();
    return address || null;
  } catch {
    return null;
  }
}
